// @flow
import { popup } from 'app/common/actions/popup';
import api from '../api';

export const TICKET_FORM_OPEN = 'TICKET_FORM_OPEN';
export const TICKET_FORM_RESET = 'TICKET_FORM_RESET';
export const TICKET_FORM_CHANGE = 'TICKET_FORM_CHANGE';
// export const TICKET_FORM_ADD_FILE = 'TICKET_FORM_ADD_FILE';


export const ticketFormOpen = () => async (dispatch: Function, getState: Function) => {
  const email = getState().user.email || '';
  dispatch({
    type: TICKET_FORM_OPEN,
    payload: { email },
  });
};

export const ticketFormReset = () => ({
  type: TICKET_FORM_RESET,
});

export const ticketFormChange = (payload: any) => ({
  type: TICKET_FORM_CHANGE,
  payload,
});

// export const ticketFormAddFile = payload => ({
//   type: TICKET_FORM_ADD_FILE,
//   payload,
// });
//

export const TICKET_FORM_SEND_REQUEST = 'TICKET_FORM_SEND_REQUEST';
export const TICKET_FORM_SEND_SUCCESS = 'TICKET_FORM_SEND_SUCCESS';
export const TICKET_FORM_SEND_FAILURE = 'TICKET_FORM_SEND_FAILURE';

const ticketSendRequest = () => ({
  type: TICKET_FORM_SEND_REQUEST,
});

const ticketSendSuccess = payload => ({
  type: TICKET_FORM_SEND_SUCCESS,
  payload,
});

const ticketSendFailure = payload => ({
  type: TICKET_FORM_SEND_FAILURE,
  payload,
});

export const ticketSend = () => async (dispatch: Function, getState: Function) => {
  const {
    email,
    updateEmail: update_email, // eslint-disable-line camelcase
    subjectId: subject_id, // eslint-disable-line camelcase
    content,
    attach: attached_file_ids, // eslint-disable-line camelcase
  } = getState().assistance.ticketForm.ticket;
  const data = {
    ticket: { subject_id, content, email, attached_file_ids },
    update_email,
  };
  dispatch(ticketSendRequest());
  try {
    const res = await api('cabinet/assistance/tickets', 'post', { data });
    const { result, ...others } = res.data;
    dispatch(ticketSendSuccess(others));
    dispatch(popup('Запрос успешно отправлен'));
    dispatch(ticketFormReset());
  } catch (error) {
    dispatch(ticketSendFailure({ err: 'Не удалось отправить запрос' }));
  }
};
